import React, { Fragment } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";

class ResetPassword extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    isShowModal: true,
    email: "",
    errMsg: "",
  };

  changeEmailHandler = (e) => {
    this.setState({
      errMsg: "",
    });
    this.setState({
      email: e.target.value,
    });
  };
  onCloseModalHandler = () => {
    this.setState({
      errMsg: "",
    });
    this.setState({
      isShowModal: false,
    });
    this.props.onCloseResetPasswordModalHandler();
  };

  render() {
    return (
      <Fragment>
        <Modal show={this.state.isShowModal} onHide={this.onCloseModalHandler}>
          <Modal.Header>
            <Modal.Title>Forgot Password</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>
                  To reset your password, enter your email below and submit. An
                  email will be sent to you with instructions about how to
                  complete the process
                </Form.Label>
                <Form.Control
                  type="email"
                  placeholder="name@example.com"
                  autoFocus
                  onChange={this.changeEmailHandler}
                />
              </Form.Group>

              {this.state.errMsg && (
                <div>
                  <p style={{ color: "red" }}>{this.state.errMsg}</p>
                </div>
              )}

              {this.props.errMsg && (
                <div>
                  <p style={{ color: "red" }}>{this.props.errMsg}</p>
                </div>
              )}
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              className="standard_purple_button"
              onClick={() => {
                if (
                  /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
                    this.state.email
                  )
                ) {
                  this.props.resetPassWordModalHandler(this.state.email);
                } else {
                  this.setState({
                    errMsg: "Please enter a vaild email",
                  });
                }
              }}
            >
              Reset Password
            </Button>
            <Button
              variant="primary"
              className="standard_purple_button"
              onClick={this.onCloseModalHandler}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      </Fragment>
    );
  }
}
export default ResetPassword;
